import { FC, useEffect } from 'react';

import { WithChildren } from '@/_metronic/helpers';
import { useAuth } from '@/hooks/useAuth';
import { useMenu } from '@/hooks/useMenu';

const MenuInit: FC<WithChildren> = ({ children }) => {
  const { setDefaultMenuList } = useMenu();
  const { currentUser } = useAuth();

  // Re-derive the sidebar whenever the user (or their permission_codes)
  // changes. The previous `[]` deps would freeze the menu against whatever
  // currentUser was at first render — fine for a fresh login (AuthInit gates
  // children below profile-fetch) but stale if perms get updated in place.
  useEffect(() => {
    setDefaultMenuList();
  }, [currentUser?.id, currentUser?.permission_codes]);

  return <>{children}</>;
};

export { MenuInit };
